import React from 'react'
import { bool } from 'prop-types'
import { Motion } from 'react-motion'

class EasingMotion extends React.PureComponent {
  static contextTypes = {
    animate: bool
  }

  canAnimate() {
    return 'animate' in this.context ? this.context.animate : this.props.animate
  }

  render() {
    if (!this.canAnimate()) {
      return this.props.children(this.props.static)
    }

    return <Motion style={this.props.style}>{this.props.children}</Motion>
  }
}

export default EasingMotion



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-motion.js